import { saveAs } from 'file-saver';
import { AuthService } from '@core/services/auth.service';
import { DataService } from '@core/services/data.service';
import { QuestionService } from '../../../data/question.service';
import { environment } from 'src/environments/environment';

import { AfterViewInit, Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { NgIf } from '@angular/common';
import { load } from '@finapi/web-form';
import { TranslateModule } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { ButtonComponent } from '@shared/components/button/button.component';
import { DownloadDialogBoxComponent } from '@shared/components/dialog-boxes/download-dialog-box/download-dialog-box.component';
import { PdfViewBoxComponent } from '@shared/components/pdf-view-box/pdf-view-box.component';
import { PinEntryComponent } from '../../pin-entry/pin-entry.component';
import { WaveService } from '@core/services/wave.service';
import { UiStateService } from '../../../data/ui-state.service';
import { NatPerson, Rol } from '@core/models/user';
import { AdminService } from '@core/services/admin.service';
import { Agree21Service } from '../../../data/agree21.service';
import { ButtonService } from '../../../data/btn.services';
import { FinapiService } from '../../../data/finapi.service';
import { CheckBoxComponent } from '@shared/components/checkbox/checkbox.component';
import { ContentCardComponent } from '@shared/components/content-card/content-card.component';
import { LoaderComponent } from '@shared/components/loader/loader.component';
import { SeparatorComponent } from '@shared/components/separator/separator.component';
import { TranslationDirective } from '@shared/components/translata-modal/translation.directive';
import { QuestionTemplate } from '../question-template';
import { BankacountsComponent } from './bankacounts/bankacounts.component';
import { KreditcheckabschlussComponent } from './kreditcheckabschluss/kreditcheckabschluss.component';
import { DOKUMENT_NAME } from '@core/models/dokument-names';
import { CdkTableModule } from '@angular/cdk/table';
import { DialogService } from '@core/services/dialog.service';
import { AccordionComponent } from '@shared/components/expansion/accordion.component';
import { ExpansionPanelHeaderComponent } from '@shared/components/expansion/expansion-panel-header.component';
import { ExpansionPanelComponent } from '@shared/components/expansion/expansion-panel.component';
import { PanelTitleComponent } from '@shared/components/expansion/panel-title.component';

export interface Dokument {
  name: string;
  position: number;
}

const VERTRAEGE_DATA: Dokument[] = [
  { name: DOKUMENT_NAME.POSTFACH, position: 1 },
  { name: DOKUMENT_NAME.GIROCARD, position: 2 },
  { name: DOKUMENT_NAME.KUNDENSTAMM_JUR, position: 4 },
  { name: DOKUMENT_NAME.ONLINEBANKING, position: 5 },
  { name: DOKUMENT_NAME.KREDIT_KONTO, position: 6 },
  { name: DOKUMENT_NAME.SEPA_FIRMEN, position: 8 },
  { name: DOKUMENT_NAME.SELBSTAUSKUNFT, position: 9 },
  { name: DOKUMENT_NAME.GWG_VERTRAGSPARTNER, position: 10 },
  { name: DOKUMENT_NAME.GWG_AUFTRETENDER, position: 11 },
  { name: DOKUMENT_NAME.KUNDENSTAMM_GBR, position: 12 },
  { name: DOKUMENT_NAME.UNTERSCHRIFT_GBR, position: 13 },
  { name: DOKUMENT_NAME.KUNDENSTAMM, position: 14 },
  { name: DOKUMENT_NAME.ABTRETUNG, position: 15 },
  { name: DOKUMENT_NAME.SELECTLIQUID, position: 16 },
];

const DOKUMENTE_DATA: Dokument[] = [
  { name: DOKUMENT_NAME.DATENSCHUTZ, position: 7 },
  { name: DOKUMENT_NAME.INFO_EINLEGER, position: 8 },
  { name: DOKUMENT_NAME.SCHUFA, position: 9 },
  { name: DOKUMENT_NAME.EINWILLIGUNG, position: 13 },
];

const AGBS_DATA: Dokument[] = [
  { name: DOKUMENT_NAME.AGB, position: 1 },
  { name: DOKUMENT_NAME.SB_ONLINE_BANKING, position: 2 },
  { name: DOKUMENT_NAME.SB_LASTSCHRIFT, position: 3 },
  { name: DOKUMENT_NAME.SB_UEBERWEISUNG, position: 4 },
  { name: DOKUMENT_NAME.SB_ECHTZEIT, position: 5 },
  { name: DOKUMENT_NAME.SB_ECHTZEIT_SAMMEL, position: 6 },
  { name: DOKUMENT_NAME.SB_GIROCARD, position: 7 },
  { name: DOKUMENT_NAME.SB_POSTFACH, position: 8 },
];

@Component({
  selector: 'app-einsicht',
  templateUrl: './einsicht.component.html',
  styleUrls: ['./einsicht.component.scss'],
  imports: [AccordionComponent, ExpansionPanelComponent, ExpansionPanelHeaderComponent, PanelTitleComponent, CdkTableModule, 
    NgIf,
    TranslationDirective,
    TranslateModule,
    LoaderComponent,
    BankacountsComponent,
    KreditcheckabschlussComponent,
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    SeparatorComponent,
    ContentCardComponent,
    CheckBoxComponent,
  ],
})
export class EinsichtComponent extends QuestionTemplate implements OnInit, AfterViewInit, OnDestroy {
  step = 1;
  identityCheckStatus = 'inprogress';
  imagelang: string;
  descriptionImagePath: string;
  lang: string;
  isAdmin: boolean;
  panelOpenState = false;
  panelOpenState2 = false;
  panelOpenState3 = false;
  isDownloading = false;
  verDataSource: Dokument[];
  dokDataSource: Dokument[];
  agbDataSource: Dokument[];
  displayedColumns: string[] = ['name', 'download'];
  baseUrl: string;
  getWebformStatus = true;
  loading: boolean;
  finapiResult: any;
  waveService = inject(WaveService);
  private readonly uiState = inject(UiStateService);
  private programmaticChange = false;
  private webFormRequested = false;

  constructor(
    private dialog: DialogService,
    auth: AuthService,
    questionService: QuestionService,
    routeActive: ActivatedRoute,
    private dataService: DataService,
    private finapiService: FinapiService,
    private router: Router,
    private adminService: AdminService,
    public btnService: ButtonService,
    private readonly agree21Service: Agree21Service,
    public admin: AdminService
  ) {
    super(auth, questionService, routeActive);
    this.questionName = 'einsicht';
    this.verDataSource = VERTRAEGE_DATA;
    this.dokDataSource = DOKUMENTE_DATA;
    this.agbDataSource = AGBS_DATA;
    this.imagelang = this.auth.user.lang;
    this.lang = this.auth.user.lang;
    this.descriptionImagePath = 'assets/img/dokumente-odfin.png';
    if (this.auth.user?.kundenNummer) {
      this.step = 4;
      this.waveService.einsichtStep.set(4);
      this.uiState.setShowCancelButton(false);
      this.adminService.updateSubStatus(this.auth.user._id, 'documents').subscribe(() => {});
    } else if (
      typeof this.auth.user.finapi?.creditCheck?.derivedCreditLimitAmount != 'undefined' ||
      (!this.auth.user.questions[0]?.answer?.kontoWechselService &&
        !this.auth.user.questions[0]?.answer?.kontokorrentkredit)
    ) {
      this.step = 3;
      this.waveService.einsichtStep.set(3);
    }
  }

  ngOnDestroy(): void {
    this.getWebformStatus = false;
    this.webFormRequested = false;
  }

  /**
   * Init variables und FormGroup machen
   */
  override ngOnInit() {
    super.ngOnInit();
    this.subscribeToConfig();
    this.isAdmin = this.auth.user.rol == Rol.admin || this.auth.user.rol == Rol.adminBB;
    this.updateVertraegeList(this.finapiResult);
    this.baseUrl = location.origin;
    this.answerFormGroup = this.createAnswerFormGroup();
    this.loadValues();
  }

  private createAnswerFormGroup(): FormGroup {
    return new FormGroup({
      heruntergeladen: new FormControl(null),
      bestätigt: new FormControl(null, [Validators.requiredTrue]),
    });
  }
  private subscribeToConfig(): void {
    this.auth.getConfig().subscribe({
      next: (response) => {
        if (response?.data?.enableWunschPinAgree) {
          this.subscribeToConfirmChanges();
        }
      },
    });
  }

  private subscribeToConfirmChanges(): void {
    this.answerFormGroup.get('bestätigt')?.valueChanges.subscribe((value) => {
      if (value === true && !this.isProgrammaticChange()) {
        this.showPinEntryDialog((result) => {
          if (result?.success) {
            this.auth.setOnlineBankingPublicKey(result.onlineBankingPublicKey);
          }
        });
      }
    });
  }

  private isProgrammaticChange(): boolean {
    const isProgrammatic = this.programmaticChange;
    this.programmaticChange = false; // Reset after checking
    return isProgrammatic;
  }

  private async showPinEntryDialog(onConfirm: (result: any) => void): Promise<void> {
    const dialogRef = this.dialog.open(PinEntryComponent, {
      width: '500px',
      data: {},
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.success === true) {
        if (!this.answerFormGroup.controls['bestätigt'].value) {
          this.programmaticChange = true;
          this.answerFormGroup.controls['bestätigt'].setValue(true);
        }
        onConfirm(result);
      } else {
        if (this.answerFormGroup.controls['bestätigt'].value) {
          this.programmaticChange = false;
          this.answerFormGroup.controls['bestätigt'].setValue(false);
        }
        onConfirm(null);
      }
    });
  }

  ngAfterViewInit() {
    let container = document.getElementById('FinApiWeb');
    if (container) {
      this.createWebForm(container);
    }
  }

  async openPdf(element) {
    const normalizeString = (str) => str?.replace(/\s+/g, '').toLowerCase();

    if (typeof element === 'number') {
      this.dataService.getRechtlichesDocument(element).subscribe((res) => {
        const blob = new Blob([res], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        this.dialog
          .open(PdfViewBoxComponent, {
            data: { pdfSrc: url },
          })
          .afterClosed()
          .subscribe(() => {
            this.loading = false;
          });
      });
    } else {
      const documents = (await firstValueFrom(this.dataService.getMyDocuments())).documents;
      const document = documents.find((doc) => {
        return normalizeString(doc.documentname) === normalizeString(element.name);
      });
      if (document) {
        const fileId = document.fileId;
        this.admin.getDocuments(fileId).subscribe((blob) => {
          this.openPdfs(blob);
        });
      } else {
        console.error('Document not found');
      }
    }
  }

  openPdfs(blob) {
    const url = window.URL.createObjectURL(blob);

    const dialogData: { pdfSrc: any } = { pdfSrc: url };
    this.dialog
      .open(PdfViewBoxComponent, {
        data: dialogData,
      })
      .afterClosed()
      .subscribe(() => {
        window.URL.revokeObjectURL(url);
      });
  }

  openAgbPdf(documentNr: number) {
    this.dataService.getRechtlichesDocument(documentNr).subscribe((res) => {
      const blob = new Blob([res], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      this.dialog
        .open(PdfViewBoxComponent, {
          data: { pdfSrc: url },
        })
        .afterClosed()
        .subscribe(() => {});
    });
  }

  downloadZip() {
    this.isDownloading = true;
    this.dialog
      .open(DownloadDialogBoxComponent, {
        data: {
          isDownloading: this.isDownloading,
        },
      })
      .afterClosed();
    this.dataService.downloadAllEinsichtDocuments().subscribe(
      (res) => {
        const blob = new Blob([res], { type: 'application/zip' });
        let name = 'Dokumente.zip';

        saveAs(blob, name);
        this.answerFormGroup.controls['heruntergeladen'].setValue(true);
      },
      (err) => {
        this.isDownloading = false;
      },
      () => {
        this.isDownloading = false;
        this.dialog.closeAll();
        this.dialog.open(DownloadDialogBoxComponent, {
          data: {
            isDownloading: this.isDownloading,
          },
        });
        setTimeout(() => {
          this.dialog.closeAll();
        }, 2000);
      }
    );
  }

  isOdfin(): boolean {
    return this.auth.user.lang == 'odfin' ? true : false;
  }

  vertraegeTitel(): string {
    const contractTitles: string[] = this.verDataSource.map((contract) => contract.name);
    return contractTitles.join('\r\n');
  }

  updateVertraegeList(result) {
    const shouldFilterPosition = (positionsToFilter, condition) => {
      return condition ? positionsToFilter : [];
    };

    const isCreditLimitZero =
      result?.derivedCreditLimitAmount === 0 || this.auth.user.finapi?.creditCheck?.derivedCreditLimitAmount === 0;
    const isCreditCardLimitZero =
      result?.derivedCreditCardLimitAmount === 0 ||
      this.auth.user.finapi?.creditCheck?.derivedCreditCardLimitAmount === 0;

    const userAnswers = this.auth.user.questions[0]?.answer;

    let positionsToFilter = [
      ...shouldFilterPosition(
        [6],
        userAnswers?.kontokorrentkredit === false || (userAnswers?.kontokorrentkredit === true && isCreditLimitZero)
      ),

      ...shouldFilterPosition([1], !this.auth.isJurPerson()), // ElektronischesPostfach only for JurPerson
      ...shouldFilterPosition(
        [12, 13],
        !this.auth.isJurPerson() || this.auth.user.JurPerson?.JurDaten?.GbrArt !== 'GbR ohne Haftungsbeschraenkung'
      ),
      ...shouldFilterPosition(
        [4],
        !this.auth.isJurPerson() || this.auth.user.JurPerson?.JurDaten?.GbrArt === 'GbR ohne Haftungsbeschraenkung'
      ),
      ...shouldFilterPosition([14], this.auth.isJurPerson()), // Kundenstamm_Vertrag only for natPerson
      ...shouldFilterPosition([8], this.isOdfin()),
      ...shouldFilterPosition([9], !this.auth.isJurPerson()),
      ...shouldFilterPosition([16], !this.checkIsSelectLiquid(this.auth.user.natPersonen)),
    ];
    positionsToFilter.push(...shouldFilterPosition([10], !this.auth.isJurPerson()));
    positionsToFilter.push(...shouldFilterPosition([15], userAnswers?.abtretungsvertrag === undefined));
    if (this.auth.isJurPerson()) {
      const { JurDaten } = this.auth.user.JurPerson;

      positionsToFilter.push(
        ...shouldFilterPosition(
          [12, 13],
          JurDaten?.RechtsformAuspraegung === 'Gesellschaft mit beschränkter Haftung (GmbH)'
        )
      );
    }

    this.verDataSource = VERTRAEGE_DATA.filter((dokument) => !positionsToFilter.includes(dokument.position));
  }

  checkIsSelectLiquid(natPersonen?: NatPerson[]): boolean {
    return this.auth.isSelectLiquid(natPersonen);
  }

  async createWebForm(container: HTMLElement) {
    if (this.webFormRequested) return;
    this.webFormRequested = true;
    var token: string;
    let self = this;
    this.finapiService.getWebForm(this.auth.user.lang).subscribe({
      next: async (res) => {
        if (res.processToken) {
          this.identityCheckStatus = 'success';
        }
        token = await Promise.resolve(res.importData.webFormId);
        this.finapiService.PROCESS_TOKEN = res.processToken;
        this.finapiService.ACCESS_TOKEN = res.accessToken;
        this.finapiService.IMPORT_ID = res.importData.importId;
        window.sessionStorage.setItem('accessToken', res.accessToken);

        /*if(window.sessionStorage.getItem('identityCheckStatus')){
      /!*TODO:after deploy check does step heave right value and is there need to have other values*!/
      this.step = 2;
    } else {*/
        load(
          container,
          {
            token: token,
            targetUrl: environment.finapi.targetUrl,
          },
          {
            onComplete: function () {
              self.step = 2;
              console.log('onComplete  :', token);
            },
            onFail: function () {
              console.log('Einsicht: onFail', token);
              console.log(self.baseUrl + '/info/error-page', 'url for redirect');
              window.location.href = self.baseUrl + '/info/error-page';
            },
            onAbort: function () {
              console.log('Einsicht: onAbort', token);
              console.log(self.baseUrl + '/einsicht', 'url for redirect');
              window.location.href = self.baseUrl + '/einsicht';
            },
            onLoadError: function () {
              console.log('Einsicht: onLoadError', token);
              console.log(self.baseUrl + '/info/error-page', 'url for redirect');
              window.location.href = self.baseUrl + '/info/error-page';
            },
          }
        );
        this.getWebFormStatus(this.finapiService.ACCESS_TOKEN, res.importData.webFormId);
        /*}*/
      },
      error: (err) => {
        console.log(err);
        //this.adminService.updateSubStatus(this.auth.user._id, "finapiStop");
        if (err.error.blockedUser) {
          this.router.navigateByUrl('/info/last-identity-error');
        } else {
          this.router.navigateByUrl('/info/error-page');
        }
      },
    });
  }

  finalize() {
    this.step = 3;
    this.waveService.einsichtStep.set(3);
    console.log('finalize: ', this.step);
  }

  getResDocuments(finapiResult) {
    this.finapiResult = finapiResult;
  }

  showDocuments() {
    this.updateVertraegeList(this.finapiResult);
    this.step = 4;
    this.waveService.einsichtStep.set(4);
    this.uiState.setShowCancelButton(false);
    this.adminService.updateSubStatus(this.auth.user._id, 'documents').subscribe(() => {});
  }

  archiveDoks() {
    this.dataService.archiveAlldocuments().subscribe(() => {
      console.log('archive Done');
    });
  }

  saveDoks() {
    this.dataService.saveAlldocumentsInDB().subscribe(() => {
      console.log('archive Done');
    });
  }

  private getWebFormStatus(accessToken: string, webFormId: string) {
    setTimeout(() => {
      this.finapiService.getWebFormStatus(accessToken, webFormId).subscribe({
        next: async (res) => {
          if ((res.status === 'NOT_YET_OPENED' || res.status === 'IN_PROGRESS') && this.getWebformStatus) {
            this.getWebFormStatus(accessToken, webFormId);
          }
          if (res.status === 'COMPLETED_WITH_ERROR') {
            if (res.payload.errorCode === 'NO_ACCOUNTS_FOR_TYPE_LIST') {
              this.router.navigateByUrl('/info/no-result-page');
            }
          }
        },
        error: (err) => {
          console.log(err, 'err of getWebFormStatus');
          // this.adminService.updateSubStatus(this.auth.user._id, "finapiStop");
          this.router.navigateByUrl('/info/error-page');
        },
      });
    }, 3000);
  }

  async handleNewGbRPerson(): Promise<void> {
    this.agree21Service.postGbRPerson(0).subscribe({
      next: (result) => {
        if (result.gbrPersonnummer) {
          this.updateUserGbRData(result);
        }
      },
    });
  }

  private updateUserGbRData(result: any): void {
    this.updateUserData(result.gbrPersonnummer, result);
  }

  private updateUserData(personNumber: number, result: any): void {
    this.agree21Service.PERSONEN_NUMMER = personNumber;
    this.agree21Service.IBAN = result.iban;
    this.auth.user.JurPerson.JurDaten.BBKundennummer = personNumber;
    this.auth.user.iban = result.iban;
    this.auth.user.tagesGeldkontoIban = result.tagesGeldkontoIban;
  }
}
